// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3or7a","rootCenter":"LoadMoreObserver_rootCenter__1LQ1O","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3L2VZ"};